export enum Claims {
  ORGANIZATION_READ = 'Organization.Read',
  ORGANIZATION_WRITE = 'Organization.Write',
  PEOPLE_READ = 'People.Read',
  DASHBOARD_READ = 'Dashboard.Read',
  ASPECT_READ = 'Aspect.Read',
  SURVEYS_READ = 'Surveys.Read',
  SURVEYS_WRITE = 'Surveys.Write',
  DEPARTMENTS_READ = 'Departments.Read',
  DEPARTMENT_READ = 'Department.Read',
  TRAINING_READ = 'Training.Read',
  PROFILE_READ = 'Profile.Read',
  BILLING_READ = 'Billing.Read',
  BILLING_WRITE = 'Billing.Write',
}
